import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
  CircularProgress,
  Link,
  Checkbox,
} from "@mui/material";
import AuthLayout from "../components/layout/auth_layout";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import { toast } from "react-toastify";
// import Spark_Logo from "../../../assets/baseVersion/Spark_Newlogo.svg";
import Spark_Logo from "../assets/baseVersion/Spark_Newlogo.svg";
import { useAuth } from "../services/auth/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import ActiveSessionModal from "../components/active_session_modal";
import { loginValidationSchema } from "./validation_schema";
const label = { inputProps: { "aria-label": "RememberMe Checkbox" } };

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showActiveSessionModal, setShowActiveSessionModal] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";

  const handleOnContinue = () => {
    formik.resetForm();
    setShowActiveSessionModal(false);
    setIsLoading(false);
    // resetCaptcha();
  };
  const handleRememberMe = () => {
    setRememberMe(!rememberMe);
  };

  //  const handleSubmit = async (e: React.FormEvent) => {
  //     e.preventDefault();
  //     setError('');
  //     setIsLoading(true);

  //     try {
  //       const success = await login(email, password);
  //       if (success) {
  //         navigate(from, { replace: true });
  //       } else {
  //         setError('Login failed. Please try again.');
  //       }
  //     } catch (err) {
  //       setError('Login failed. Please try again.');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const handleSubmit = async (data: any) => {
    setIsLoading(true);

    try {
      // Clear any existing sessions before attempting login
      localStorage.removeItem("authToken");
      localStorage.removeItem("userData");
      delete axiosInstance.defaults.headers.common["Authorization"];
      await new Promise((resolve) => setTimeout(resolve, 100));

      const result: any = await login(data.email, data.password, false);
      console.log("Login result:", result);

      if (result?.active_session) {
        setIsLoading(false);
        setShowActiveSessionModal(true);
        return;
      } else if (result?.success === false) {
        // Handle login failure with specific error message
        toast.error(result.message || "Login failed. Please try again.");
        return;
      } else if (result && Object.keys(result).length === 0) {
        // Successful login (empty object returned)
        toast.success("You have successfully signed in.");
        setTimeout(() => {
          navigate(from, { replace: true });
        }, 1000);
      } else {
        toast.error("Something went wrong!");
      }
    } catch (err: any) {
      toast.error(err.message || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginValidationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      <AuthLayout>
        <Box component="form" onSubmit={formik.handleSubmit}>
          <div style={{ padding: "30px", width: "100%" }}>
            <img src={Spark_Logo} alt="Login Logo" style={{ width: 100 }} />

            <Typography sx={{ fontWeight: "bold", fontSize: "20px", mb: 2 }}>
              Sign In
            </Typography>
            <Typography sx={{ mb: 3, color: "#696595" }}>
              Enter your details to Sign In and explore more
            </Typography>
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              required
              fullWidth
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              sx={{ mb: 3 }}
            />
            <TextField
              id="password"
              label="Password"
              variant="outlined"
              fullWidth
              required
              type={showPassword ? "text" : "password"}
              name="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <span className="visibility-icon">
                        {showPassword ? (
                          <Visibility
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        ) : (
                          <VisibilityOff
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        )}
                      </span>
                    </InputAdornment>
                  ),
                },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  ...(!showPassword && { font: "initial" }),
                },
              }}
            />
            {/* <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              disabled={isLoading}
              placeholder="Enter any email (e.g., test@example.com)"
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              disabled={isLoading}
              placeholder="Enter any password"
            /> */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                marginTop:"20px"
              }}
              className="mb_3"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="text-muted"
              >
                <Checkbox
                  {...label}
                  size="small"
                  className="remember_checkbox"
                  onChange={handleRememberMe}
                />
                <Typography className="remember_link">Remember me</Typography>
              </div>
              <Link
                href="/forgot-password"
                underline="none"
                sx={{
                  color: "gray",
                  fontSize: "0.875rem",
                  "&:hover": {
                    color: "blue",
                  },
                }}
              >
                Forgot Password?
              </Link>
            </div>

            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
              type="submit"
              disabled={
                isLoading ||
                !formik.isValid ||
                !formik.values.email ||
                !formik.values.password
              }
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              {isLoading ? "Signing In..." : "Sign In"}
            </Button>
          </div>
        </Box>
      </AuthLayout>
      {showActiveSessionModal && (
        <ActiveSessionModal
          open={showActiveSessionModal}
          onContinue={handleOnContinue}
          onSignInAgain={async () => {
            setShowActiveSessionModal(false);
            setIsLoading(true);
            try {
              const result: any = await login(
                formik.values.email,
                formik.values.password,
                true
              );
              if (result?.success === false) {
                // Handle login failure with specific error message
                toast.error(result.message || "Login failed. Please try again.");
              } else if (result && Object.keys(result).length === 0) {
                // Successful login (empty object returned)
                toast.success("You have successfully signed in.");
                setTimeout(() => {
                  navigate(from, { replace: true });
                }, 1000);
              } else {
                toast.error("Something went wrong!");
              }
            } catch (err: any) {
              toast.error(err.message || "Login failed. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
        />
      )}
    </>
  );
};

export default Login;
